import Readers from "screens/private/readers-tags/readers";
export default Readers;
